var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen",attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"simple-fade","mode":"out-in"}},[_c('router-view')],1),_c('portal-target',{attrs:{"name":"modals","slim":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }